import React from 'react'

import {
  Header, Comparison, ComparisonMobile, FAQs 
} from '@components/templates/pricing'
import { Layout } from '@components/Layout'

type PricingPageProps = {
  data: {
    pagedata: {
      title: string
      meta_title: string
      meta_desc: string
      enable_no_follow_no_index: boolean
      _rawPagebuildersection: any[]
    }
  }
  location: {
    href: string
    pathname: string
    search: string
  }
}

export const PricingPage = ({ location, data: {pagedata} }: PricingPageProps) => (
  <Layout location={location}>
    {pagedata._rawPagebuildersection.map(section => {
      let faqs = []
      switch (section._type) {
      case 'hero_banner_pricing':
        return <Header {...section} />
      case 'pricing_comparision_with_title':
        return (
          <>
            <Comparison {...section} />
            <ComparisonMobile {...section} />
          </>
        )
      case 'faq':
        faqs = section.faqcontent.map(({ faq_question: question, faq_answer: answer }) => ({ question, answer }))
        return (
          <FAQs
            title={section.faqtitle}
            faqs={faqs}
          />
        )
      default: 
        return null
      }
    })}
  </Layout>
)